import { render, staticRenderFns } from "./RegistSelecter.vue?vue&type=template&id=f7772d52&"
import script from "./RegistSelecter.vue?vue&type=script&lang=js&"
export * from "./RegistSelecter.vue?vue&type=script&lang=js&"
import style0 from "./RegistSelecter.vue?vue&type=style&index=0&id=f7772d52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports